var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nodeIds)?_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Compute Nodes")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._v("\n    "+_vm._s(_vm.nodeNames)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2083944f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ComputeNodes.vue
// module id = Rd+G
// module chunks = 1